import { Module, VuexModule, Mutation, config } from "vuex-module-decorators";
import { IBank, IBankAccount } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class BankModule extends VuexModule {
  bankAccounts: IBankAccount[] = [];
  newBankAccounts: IBankAccount[] = [];
  banks: IBank[] = [];
  deletedBanks: IBankAccount[] = [];

  @Mutation
  setBankDetails(bankDetails: {
    bankAccounts: IBankAccount[];
    banks: IBank[];
  }) {
    this.bankAccounts = bankDetails.bankAccounts;
    this.banks = bankDetails.banks;
    // this.deletedBanks = bankDetails.deletedBanks;
  }

  @Mutation
  setNewBankDetails(bankDetails: {
    newBankAccounts: IBankAccount[];
    banks: IBank[];
  }) {
    this.newBankAccounts = bankDetails.newBankAccounts;
    this.banks = bankDetails.banks;
    // this.deletedBanks = bankDetails.deletedBanks;
  }

  @Mutation
  setBankAccounts(bankAccounts: IBankAccount[]) {
    this.bankAccounts = bankAccounts;
    this.newBankAccounts = bankAccounts;
  }

  @Mutation
  pushBankAccounts(bankAccounts: IBankAccount[]) {
    this.bankAccounts.push(...bankAccounts);
    this.newBankAccounts.push(...bankAccounts);
  }

  @Mutation
  clear() {
    this.bankAccounts = [];
    this.newBankAccounts = [];
    this.banks = [];
    this.deletedBanks = [];
  }
}
